import {
  faArrowRightFromBracket,
  faChartSimple,
  faChevronLeft
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  IonBackButton,
  IonBadge,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonItem,
  IonLabel,
  IonList,
  IonMenuButton,
  IonPage,
  IonProgressBar,
  IonRow,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import "./home.scss";
import { useEffect, useState } from "react";
import Glide from "@glidejs/glide";
import coffeeTools from "../../CoffeeTools";
import { count, table } from "console";
import lnbp_logo from "../../icon/icon.png";
import NextGame from "../../components/home/NextGame";

const Home: React.FC = () => {
  const [showProgessBar, setShowProgessBar] = useState(true);
  let base_url = process.env.REACT_APP_BASE_URL;
  let id_season = process.env.REACT_APP_ID_SEASON;
  //declared outside to make it global and used it on the page
  let sliderNews = null;
  let sliderVideos = null;
  let coffee_tools = new coffeeTools();

  const [news, setNews] = useState([]);
  const [videos, setVideos] = useState([]);
  const [lnbpContigo, setLnbpContigo] = useState([]);
  const [todayGames, setTodayGames] = useState([]);

  useEffect(() => {
    // show slider
    //start the page
    mainController.init();
    // console.log(coffee_tools.test(123));
  }, []);

  var controller = (() => {
    async function getNews(callback) {
      // call the progress bar
      return await fetch(
        process.env.REACT_APP_BASE_URL + "/communication/news/all",
        {
          method: "Post",
          credentials: "omit",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            count: "6"
          })
        }
      )
        .then((response) => response.json())
        .then((response) => {
          callback(response);
        });
    }
    function getVideos(callback) {
      // call the progress bar

      fetch(base_url + "/media/videos/filtered", {
        method: "Post",
        credentials: "omit",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          count: "6"
        })
      })
        .then((response) => response.json())
        .then((response) => {
          callback(response);
        });
    }
    function getLnbpContigo(callback) {
      // call the progress bar

      fetch(base_url + "/communication/news/all", {
        method: "Post",
        credentials: "omit",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          count: 10,
          id_category: 237
        })
      })
        .then((response) => response.json())
        .then((response) => {
          callback(response);
        });
    }
    function getTeams(callback) {
      fetch(base_url + "/sports/seasons/participants/latest", {
        method: "Post",
        credentials: "omit",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id_season: id_season
        })
      })
        .then((response) => response.json())
        .then((response) => {
          callback(response);
        });
    }
    function getBanner(callback) {
      fetch(base_url + "/cms/entries/single", {
        method: "Post",
        credentials: "omit",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: 29
        })
      })
        .then((response) => response.json())
        .then((response) => {
          callback(response);
        });
    }
    function getStandings(callback) {
      fetch(base_url + "/sports/standings/season", {
        method: "Post",
        credentials: "omit",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id_season: id_season
        })
      })
        .then((response) => response.json())
        .then((response) => {
          callback(response);
        });
    }
    function getSocialNetworkCompany(callback) {
      let company_id = 2; //lnbp company id
      fetch(base_url + "/business/companies/single", {
        method: "Post",
        credentials: "omit",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: company_id
        })
      })
        .then((response) => response.json())
        .then((response) => {
          callback(response);
        });
    }
    function getSponsors(callback) {
      let sponsors_available = [
        {
          name: "Molten",
          url: "https://www.facebook.com/MoltenBasketMx",
          icon: "../../assets/sponsors/1_Molten.png"
        },
        {
          name: "Value",
          url: "https://www.value.com.mx/",
          icon: "../../assets/sponsors/value_logo.png"
        },
        {
          name: "Punto CHG",
          url: "http://grupovicoru.com/",
          icon: "../../assets/sponsors/3_PuntoCHG.png"
        },

        {
          name: "Caliente",
          url: "https://www.caliente.mx/ofertas/sponsors/LNBP/",
          icon: "../../assets/sponsors/4_CalienteMX.png"
        }
      ];

      callback(sponsors_available);
    }

    async function getVideoNextGames() {
      return await fetch(base_url + "/sports/games/filtered", {
        method: "Post",
        credentials: "omit",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          next_games: true,
          count: 8
        })
      }).then((response) => response.json());
    }

    return {
      getNews: (callback) => getNews(callback),
      getVideos: (callback) => getVideos(callback),
      getLnbpContigo: (callback) => getLnbpContigo(callback),
      getTeams: (callback) => getTeams(callback),
      getBanner: (callback) => getBanner(callback),
      getStandings: (callback) => getStandings(callback),
      getSocialNetworkCompany: (callback) => getSocialNetworkCompany(callback),
      getSponsors: (callback) => getSponsors(callback),
      getVideoNextGames: () => getVideoNextGames()
    };
  })();

  let view = (() => {
    let dom_obj = {
      glide_class: ".glide",
      video_title: "js__header_title_videos_title",
      lnbp_contigo_title: "js__header_title_lnbp_contigo_title",
      teams_title: "js__teams_title",
      standings_title: "js__standings_title",
      teams_list: "js__teams_list",
      banner_top: "js__banner_image",
      // standings_table: "js__standings_table",
      social_networks: "js__social_network_container",
      social_network_title: "js__social_network_title",
      sponsors_container: "js__sponsors_container",
      sponsors_title: "js__sponsors_title"
    };

    // news sections
    function showNewsSlider() {
      sliderNews = new Glide(dom_obj.glide_class, {
        type: "carousel",
        startAt: 0,
        perView: 1,
        autoplay: 3000, //this should be 3000
        hoverpause: true
      });

      sliderNews.mount();
    }

    function showNews(news) {
      let newsListHtml = [];
      // console.log(news);
      news.items.forEach((element) => {
        newsListHtml.push(
          <li
            className='glide__slide news'
            key={element.id}
          >
            <a
              href={"/news?id=" + element.id}
              rel='noopener noreferrer'
            >
              <img
                alt={element.name}
                className='glide__slide__img'
                src={base_url + element.full_url_image}
              ></img>
              <div>
                <h6 dangerouslySetInnerHTML={{ __html: element.name }}></h6>
                <hr />
                <span
                  dangerouslySetInnerHTML={{
                    __html:
                      element.description.replaceAll("<br>", "").slice(0, 100) +
                      "..."
                  }}
                ></span>
              </div>
            </a>
          </li>
        );
      });

      setNews(newsListHtml);

      // load the slider
      showNewsSlider();
    }

    // videos sections
    function showVideosSlider() {
      sliderVideos = new Glide("#js__glide_video", {
        type: "carousel",
        startAt: 0,
        perView: 1,
        autoplay: 3000, //this should be 3000
        hoverpause: true
      });

      sliderVideos.mount();
    }

    function showVideos(videos) {
      let videos_slides = [];
      videos.items.forEach((element) => {
        videos_slides.push(
          <li
            className='glide__slide videos ion-text-center'
            key={element.id}
          >
            <a
              href={element.url}
              target='_blank'
              rel='noopener noreferrer'
            >
              <img
                alt={element.name}
                className='glide__slide__img'
                src={base_url + element.full_url_thumbnail}
              ></img>
              <div>
                <h6 dangerouslySetInnerHTML={{ __html: element.name }}></h6>
                <hr />
                <span
                  dangerouslySetInnerHTML={{
                    __html: element.created_at
                      .replaceAll("<br>", "")
                      .slice(0, 10)
                  }}
                ></span>
              </div>
            </a>
          </li>
        );
      });

      setVideos(videos_slides);
      showVideosSlider();
    }

    // videos sections
    function showLnbpContigoSlider() {
      sliderVideos = new Glide("#js__glide_lnbp_contigo", {
        type: "carousel",
        startAt: 0,
        perView: 1,
        autoplay: 3000, //this should be 3000
        hoverpause: true
      });

      sliderVideos.mount();
    }

    function showLnbpContigo(videos) {
      let lnbp_contigo = [];

      videos.items.forEach((element) => {
        lnbp_contigo.push(
          <li
            className='glide__slide videos ion-text-center'
            key={element.id}
          >
            <img
              alt={element.name}
              className='glide__slide__img'
              src={base_url + element.full_url_thumbnail}
            ></img>
            <div>
              <h6 dangerouslySetInnerHTML={{ __html: element.name }}></h6>
              <hr />
              <span
                dangerouslySetInnerHTML={{
                  __html: element.created_at.replaceAll("<br>", "").slice(0, 10)
                }}
              ></span>
            </div>
          </li>
        );
      });

      setLnbpContigo(lnbp_contigo);
      showLnbpContigoSlider();
    }

    // banner
    function showBanner(response) {
      let image_container = document.getElementById(dom_obj.banner_top);
      image_container.innerHTML = "";
      let image = document.createElement("img");
      image.src = base_url + response.item.full_url_image;

      if (
        response.item.full_url_image != null &&
        !response.item.full_url_image.includes("no-image.jpg")
      ) {
        image_container.appendChild(image);
      }
    }
    // teams sections
    //this methos is used by displayTeams until de cms is fix and updated
    //aug 18 2021
    // this work in showTeams function, don't delete, is not in use at the moment
    // function searchTeamConference(nameKey, myArray) {
    //   for (var i = 0; i < myArray.length; i++) {
    //     if (myArray[i].id === nameKey) {
    //       return myArray[i].pivot.id_conference;
    //     }
    //   }
    // }
    // teams sections
    // function showTeams(response) {
    //   let container = document.getElementById(dom_obj.teams_list);
    //   container.innerHTML = "";
    //   response.items_team.forEach(function (item) {
    //     // this works but is not in use at the moment, don't delete
    //     // let $conference = searchTeamConference(
    //     //   item.id_entity,
    //     //   response.season.participants
    //     // );
    //     let team = document.createElement("a");
    //     team.href = item.contact.website;

    //     let team_img = document.createElement("img");
    //     team_img.src = base_url + item.full_url_logo;

    //     team.appendChild(team_img);
    //     container.appendChild(team);
    //   });
    // }

    // standings sections
    // function showStandings(response) {
    //   let standings_table = document.getElementById(dom_obj.standings_table);
    //   standings_table.innerHTML = "";

    //   let table_head = document.createElement("thead");
    //   let table_tr = document.createElement("tr");
    //   let table_body = document.createElement("tbody");

    //   ["", "EQUIPO", "JJ", "JG", "JP", "PTS"].forEach((item) => {
    //     let table_th = document.createElement("th");
    //     table_th.innerText = item;
    //     table_tr.appendChild(table_th);
    //   });

    //   standings_table.appendChild(table_head);
    //   standings_table.appendChild(table_body);
    //   table_head.appendChild(table_tr);

    //   if (response.items_standing.length > 0) {
    //     response.items_standing.forEach(function (item) {
    //       let id_conference = 0;

    //       response.item_season.participants.forEach((item_participant) => {
    //         if (item_participant.id === item.team.id_entity) {
    //           if (item_participant.pivot.id_conference !== null) {
    //             id_conference = item_participant.pivot.id_conference;
    //           }
    //           return;
    //         }
    //       });

    //       let table_body_row = document.createElement("tr");
    //       table_body_row.classList.add("standing_table_row");
    //       let team_logo = document.createElement("img");
    //       team_logo.src = base_url + item.team.full_url_logo;

    //       [
    //         team_logo,
    //         item.team.name,
    //         item.games,
    //         item.games_won,
    //         item.games_lost,
    //         item.points
    //       ].forEach((item) => {
    //         let table_cell = document.createElement("td");

    //         item instanceof HTMLElement
    //           ? table_cell.appendChild(item)
    //           : (table_cell.innerHTML = item);
    //         table_body_row.appendChild(table_cell);
    //       });

    //       table_body.appendChild(table_body_row);
    //     });
    //   } else {
    //     standings_table.append(
    //       "<tr><td colspan='4'>No se han registrado puntuaciones.</td></tr>"
    //     );
    //   }
    // }

    // tools and helpers
    function createSectionTitles(title, dom_obj_id) {
      let container = document.getElementById(dom_obj_id);
      container.innerHTML = "";

      coffee_tools.createSectionTitle(title, container);
    }

    function showSocialNetworkCompany(response) {
      let social_networks_available = [];

      if (response.item.facebook_url != null) {
        let anchor = document.createElement("a");
        anchor.href = response.item.facebook_url;

        let icon = document.createElement("img");
        icon.src = "../../assets/icon/1_Facebook.svg";

        anchor.appendChild(icon);
        social_networks_available.push(anchor);
      }
      if (response.item.instagram_url != null) {
        let anchor = document.createElement("a");
        anchor.href = response.item.instagram_url;

        let icon = document.createElement("img");
        icon.src = "../../assets/icon/2_Instagram_rojo.svg";

        anchor.appendChild(icon);
        social_networks_available.push(anchor);
      }
      if (response.item.twitter_url != null) {
        let anchor = document.createElement("a");
        anchor.href = response.item.twitter_url;

        let icon = document.createElement("img");
        icon.src = "../../assets/icon/3_Twitter.svg";

        anchor.appendChild(icon);
        social_networks_available.push(anchor);
      }
      if (response.item.youtube_url != null) {
        let anchor = document.createElement("a");
        anchor.href = response.item.youtube_url;

        let icon = document.createElement("img");
        icon.src = "../../assets/icon/4_Youtube.svg";

        anchor.appendChild(icon);
        social_networks_available.push(anchor);
      }

      let social_network_container = document.getElementById(
        dom_obj.social_networks
      );
      social_network_container.innerHTML = "";
      social_networks_available.forEach((item) => {
        social_network_container.appendChild(item);
      });
    }

    function showSponsors(response) {
      let sponsors_container = document.getElementById(
        dom_obj.sponsors_container
      );
      sponsors_container.innerHTML = "";

      let sponsors = document.createElement("div");

      sponsors.classList.add("social_network_banner");
      response.forEach(function (sponsor) {
        let anchor = document.createElement("a");
        anchor.href = sponsor.url;

        let icon = document.createElement("img");
        icon.src = sponsor.icon;

        anchor.appendChild(icon);
        sponsors.appendChild(anchor);
      });

      let sponsor_container = document.getElementById(
        dom_obj.sponsors_container
      );
      sponsor_container.appendChild(sponsors);
    }
    return {
      showNews: (news) => showNews(news),
      createSectionTitles: (title, container) =>
        createSectionTitles(title, container),
      dom_obj: dom_obj,
      showVideos: (videos) => showVideos(videos),
      showLnbpContigo: (videos) => showLnbpContigo(videos),
      // showTeams: (response) => showTeams(response),
      showBanner: (response) => showBanner(response),
      // showStandings: (response) => showStandings(response),
      showSocialNetworkCompany: (response) =>
        showSocialNetworkCompany(response),
      showSponsors: (response) => showSponsors(response)
    };
  })();

  var mainController = (function (page_controller, page_view) {
    var setupEventListeners = function () {};
    return {
      init: function () {
        // console.log("Menu started");
        setupEventListeners();
        // show news slider top of the page
        page_controller.getNews(view.showNews).then(() => {
          setShowProgessBar(false);
        });

        // top banner
        // page_controller.getBanner(page_view.showBanner);
        coffee_tools.showRotateBanner();

        // standings
        // page_controller.getStandings(page_view.showStandings);

        // set teams
        // page_view.createSectionTitles("Equipos", page_view.dom_obj.teams_title);
        // page_controller.getTeams(page_view.showTeams);

        // set standings
        // page_view.createSectionTitles(
        //   "Tabla de Posiciones",
        //   page_view.dom_obj.standings_title
        // );

        // set videos
        page_view.createSectionTitles("Vídeos", page_view.dom_obj.video_title);
        page_controller.getVideos(page_view.showVideos);

        // set lnbp contigo
        page_view.createSectionTitles(
          "LNBP Contigo",
          page_view.dom_obj.lnbp_contigo_title
        );
        page_controller.getLnbpContigo(page_view.showLnbpContigo);

        //show social networks
        page_view.createSectionTitles(
          "Redes Sociales",
          page_view.dom_obj.social_network_title
        );

        page_controller.getSocialNetworkCompany(
          page_view.showSocialNetworkCompany
        );

        // show sponsors
        page_view.createSectionTitles(
          "Patrocinadores",
          page_view.dom_obj.sponsors_title
        );
        page_controller.getSponsors(page_view.showSponsors);

        // get next games
        page_controller.getVideoNextGames().then((response) => {
          console.log(response);
          setTodayGames(response.items);
        });
      }
    };
  })(controller, view);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar
          className='home_toolbar'
          color={"secondary"}
        >
          <div hidden={!showProgessBar}>
            <IonProgressBar type='indeterminate'></IonProgressBar>
          </div>
          <IonButtons slot='start'>
            <IonMenuButton></IonMenuButton>
          </IonButtons>
          <div className='header_lnbp_icon'>
            <img
              src={lnbp_logo}
              alt='LNBP'
            />
          </div>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div hidden={!showProgessBar}>
          <IonProgressBar type='indeterminate'></IonProgressBar>
        </div>
        <div style={{ display: "flex", overflowX: "auto", flexWrap: "nowrap" }}>
          {todayGames.map((item) => (
            <NextGame
              key={item.id}
              game={{
                team_1: item.team_1.full_url_logo,
                team_2: item.team_2.full_url_logo,
                date: item.event.date_start,
                time: item.event.time_start,
                score_1: item.score_1,
                score_2: item.score_2
              }}
            ></NextGame>
          ))}
        </div>

        {/* home upper banner */}
        <section id='js__news_banner'>
          <div className='glide'>
            <div
              data-glide-el='track'
              className='glide__track'
            >
              <ul className='glide__slides'>
                {news.map((element) => element)}
              </ul>
              <div className='glide__bullets__container'>
                <div
                  className='slider__bullets glide__bullets'
                  data-glide-el='controls[nav]'
                >
                  <button
                    className='slider__bullet glide__bullet'
                    data-glide-dir='=0'
                  ></button>

                  <button
                    className='slider__bullet glide__bullet'
                    data-glide-dir='=1'
                  ></button>

                  <button
                    className='slider__bullet glide__bullet'
                    data-glide-dir='=2'
                  ></button>

                  <button
                    className='slider__bullet glide__bullet'
                    data-glide-dir='=3'
                  ></button>

                  <button
                    className='slider__bullet glide__bullet'
                    data-glide-dir='=4'
                  ></button>

                  <button
                    className='slider__bullet glide__bullet'
                    data-glide-dir='=5'
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* top banner */}
        <section
          id='js__top_banner'
          style={{ height: "8rem", marginTop: "1rem" }}
        >
          <a id='js__banner_image_anchor'>
            <img
              id='js__banner_image'
              className='banner_center ion-text-center'
              alt='banner'
            />
          </a>
        </section>
        {/* Lideres Indivuduales */}
        {/* <section id='js__standings'>
          <span id='js__standings_title'></span>
          <IonGrid>
            <IonRow>
              <IonCol className='ion-text-center'>
                <table
                  className='standing_table'
                  id='js__standings_table'
                ></table>
              </IonCol>
            </IonRow>
          </IonGrid>
        </section> */}
        {/* section with videos */}
        <section id='js__last_videos'>
          <span id='js__header_title_videos_title'></span>
          <div
            id='js__glide_video'
            className='glide'
          >
            <div
              data-glide-el='track'
              className='glide__track'
            >
              <ul className='glide__slides'>
                {videos.map((element) => element)}
              </ul>
            </div>
          </div>
        </section>
        {/* section with videos */}
        <section id='js__last_lnbp_contigo'>
          <span id='js__header_title_lnbp_contigo_title'></span>
          <div
            id='js__glide_lnbp_contigo'
            className='glide'
          >
            <div
              data-glide-el='track'
              className='glide__track'
            >
              <ul className='glide__slides'>
                {lnbpContigo.map((element) => element)}
              </ul>
            </div>
          </div>
        </section>
        {/* teams */}
        <section id='js__teams'>
          <span id='js__teams_title'></span>
          <div
            id='js__teams_list'
            className='teams_banner'
          ></div>
        </section>
        {/* social network */}
        <section id='js__social_network'>
          <span id='js__social_network_title'></span>
          <div
            id='js__social_network_container'
            className='social_network_banner'
          ></div>
        </section>

        {/* sponsors */}
        <section id='js__sponsors'>
          <span id='js__sponsors_title'></span>
          <div
            style={{ backgroundColor: "white" }}
            id='js__sponsors_container'
            className='sponsors_banner'
          ></div>
        </section>
      </IonContent>
    </IonPage>
  );
};

export default Home;
